<template>
  <div 
    class="mt-0">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.warning"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_warning.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Harap mengisi
                  <span v-if="filter.start_date === ''">tanggal mulai periode</span><span v-if="filter.start_date === '' && filter.end_date === '' && (filter.coa === '' || filter.coa === null)">, </span><span v-if="filter.start_date === '' && filter.end_date === '' && filter.coa !== '' && filter.coa !== null"> dan </span>
                  <span v-if="filter.end_date === ''">tanggal akhir periode</span><span v-if="(filter.start_date === '' && (filter.coa === '' || filter.coa === null)) || (filter.end_date === '' && (filter.coa === '' || filter.coa === null))"> dan </span>
                  <span v-if="filter.coa === '' || filter.coa === null">Chart of Account</span>
                  terlebih dahulu
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.error"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_warning.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  {{ message.error }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form_detail"
          @keydown.esc="dialog.form_detail = false"
          width="900"
          persistent
          scrollable>
          <v-card 
            :class="'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Detail RAB Internal
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.form_detail = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col cols="6" class="py-0">
                      <ValidationProvider
                        name="Nama" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          <span class="red--text">*</span>
                          Nama
                        </div>

                        <v-text-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Nama"

                          hide-details
                          autofocus

                          v-model="form.name"
                          :success="form.name !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.name !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <ValidationProvider
                        name="kategori" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          <span class="red--text">*</span>
                          Kategori
                        </div>

                        <v-autocomplete
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Kategori"

                          hide-details
                          item-text="name"
                          item-value="id"
                          :items="['Alat', 'Material', 'Upah']"

                          v-model="form.category"
                          :success="form.category !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.category !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <ValidationProvider 
                        name="Satuan" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          <span class="red--text">*</span>
    
                          Satuan
                        </div>
    
                        <v-text-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense
    
                          :color="set_color"
                          placeholder="Satuan"
    
                          hide-details
    
                          v-model="form.unit"
                          :success="form.unit !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
    
                            <div v-if="form.unit !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <ValidationProvider 
                        name="Harga" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          <span class="red--text">*</span>
    
                          Harga
                        </div>
    
                        <v-currency-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense
    
                          :color="set_color"
                          placeholder="Harga"
    
                          hide-details
    
                          v-model="form.price"
                          :success="form.price !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
    
                            <div v-if="form.price !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form_detail = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form_par"
          @keydown.esc="dialog.form_par = false"
          width="700"
          persistent
          scrollable>
          <v-card 
            :class="'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} RAB Internal <span v-if="form.par_id !== '0'">{{ name_par }}</span>
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.form_par = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Nama" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          <span class="red--text">*</span>
                          Nama Jenis Pekerjaan
                        </div>

                        <v-text-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Nama Jenis Pekerjaan"

                          hide-details
                          autofocus

                          v-model="form.name"
                          :success="form.name !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.name !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row v-if="num_children === 2">
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Satuan" 
                        rules="" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          Satuan
                        </div>

                        <v-text-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Satuan"


                          hide-details
                          autofocus

                          v-model="form.unit"
                          :success="form.unit !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.unit !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Volume" 
                        rules="" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          Volume
                        </div>

                        <v-currency-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Volume"

                          hide-details
                          :auto-decimal-mode="false"
                          :decimal-length="2"
                          

                          v-model="form.volume"
                          :success="form.volume !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.volume !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                    <!-- <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Harga Satuan" 
                        rules="" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          Harga Satuan
                        </div>

                        <v-currency-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Harga Satuan"
                          @input="form.public_price = form.internal_price * form.volume"

                          hide-details
                          autofocus

                          v-model="form.internal_price"
                          :success="form.internal_price !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.internal_price !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="jumlah harga" 
                        rules="" 
                        v-slot="{ errors, valid }">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          jumlah harga
                        </div>

                        <v-currency-field
                          v-on:keydown.enter.prevent="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="jumlah harga"

                          hide-details
                          autofocus

                          v-model="form.public_price"
                          :success="form.public_price !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.public_price !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col> -->
                  </v-row>
                </v-form>
              </ValidationObserver>
              

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form_par = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="900"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                Input Detail RAB Internal
              </div>

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon> -->

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false; fetch();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0">
              <Detail :list="list" :detail_project="detail_project" />
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="dialog.form = false; reset(); fetch();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-row
            class="pa-4 py-0">
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-0">
              <v-btn
                color="#4B4B4B"
                elevation="0"
                small
                v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Persiapan' ? false : true : false"
                :disabled="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Persiapan' ? true : false : true"
                min-height="30"
                @click="reset(); dialog.form_par = true;"
                class="fs-12 white--text text-capitalize d-flex align-center"
                style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                
                <span
                  class="ml-2 ">
                  Tambah
                </span>
              </v-btn>
              <v-btn
                color="blue"
                elevation="0"
                :disabled="!is_detail && Object.keys(detail_project).length < 1"
                small
                @click="dialog.form = true; dialog.fullscreen = true;"
                class="fs-12 white--text text-capitalize d-flex align-center ml-3"
                style="border-radius: 6px; font-weight: 600;">
                <v-icon size="15">mdi-check-circle-outline</v-icon>
                
                <span
                  class="ml-2">
                  <span v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Persiapan' ? false : true : false">Input</span> Detail RAB Internal
                </span>
              </v-btn>
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                min-height="30"
                class="ml-3 fs-12 little-placeholder"
                style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
              </v-text-field>
              <div class="ml-3 black--text">
                Total:  
                <span class="font-weight-bold pl-1 black--text">
                  Rp. {{ total.internal | number_dec }}
                </span>
              </div>

              <!-- <div class="ml-3" v-if="hak_akses.action.export">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exports()"
                      :loading="process.export"
                      elevation="0"
                      dark
                      min-height="28"
                      small
                      min-width="28"
                      color="#097640"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Export Excel
                  </span>
                </v-tooltip>
              </div> -->

              <!-- FREEZE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div> -->

              <!-- HIDE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div> -->
            </v-col>
          </v-row>

          <v-row
            class="pa-4 mt-0 pb-0 pt-2">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <div class="view" v-if="!process.load">
                  <div :class="list.length < 1 ? '' : 'wrapper_internal'">
                    <table style="border: 1px solid #ededed; width: 100%;" class="table">
                      <tr>
                        <th class="sticky-col one-col" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 120px; min-width: 120px; max-width: 120px;" :style="`background-color: ${set_color};`">Aksi</th>
                        <!-- <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;">No Rekening</th> -->
                        <!-- <th class="sticky-col three-col" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 8px; text-align: left; width: 50px; min-width: 50px; max-width: 50px;" :style="`background-color: ${set_color};`">No</th> -->
                        <th class="sticky-col second-col" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="`background-color: ${set_color};`">Jenis Pekerjaan</th>
                        <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 100px; min-width: 100px; max-width: 100px;" :style="`background-color: ${set_color};`">Volume</th>
                        <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Satuan</th>
                        <!-- <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left;" :style="`background-color: ${set_color};`">Keterangan</th> -->
                        <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">Harga Satuan</th>
                        <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">Jumlah Harga</th>
                        <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 160px; min-width: 160px; max-width: 160px;" :style="`background-color: ${set_color};`">Jumlah</th>
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = (((`100${index}`) + index) * (i+1))" :class="selected.row === (((`100${index}`) + index) * (i+1)) ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 2px; text-align: center; background-color: #fff;" :style="item.num_children === 0 ? index !== 0 ? ' border-top: solid #ededed;' : '' : ''">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="reset(item); dialog.form_par = true;"
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="24" min-height="24"
                                x-small
                                :disabled="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Persiapan' ? true : false : true"
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>
                          <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  min-width="24" min-height="24"
                                  x-small
                                  rounded
                                  :disabled="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Persiapan' ? true : item.num_children === 2 ? true : false : true"
                                  @click="dialog.form_par = true; resetSub(item);"
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="15">mdi-plus-circle</v-icon>
                                  
                                </v-btn>
                              </template>
      
                              <span>Tambah</span>
                            </v-tooltip>
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id); dialog.fullscreen = false;"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="24" min-height="24"
                                  x-small
                                  :disabled="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Persiapan' ? true : item.is_child ? true : false : true"
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="15">mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <span>Hapus</span>
                            </v-tooltip>
                        </td>
                        <!-- <td class="sticky-col three-col" style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 8px; text-align: left;" :style="item.num_children === 1 ? 'font-weight: 600;' : item.num_children === 0 ?  index !== 0 ? 'font-weight: 700; border-top: solid #ededed;' : 'font-weight: 700;' : ''">
                          <span v-if="item.num_children === 2">{{ item.no_par_par }}.</span><span v-if="item.num_children !== 0">{{ item.no_par }}.</span>{{ item.no }}
                        </td> -->
                        <td class="sticky-col second-col" style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;" :style="item.num_children === 1 ? 'font-weight: 600; padding-left: 18px;' : item.num_children === 2 ? 'padding-left: 24px;' : ''">
                          <div>
                            <span v-if="item.code !== undefined">{{ item.code }}. </span>{{ item.name }}
                          </div>
                          <!-- <div class="d-flex">
                            <v-tooltip 
                              top
                              v-if="hak_akses.action.update">
                              <template v-slot:activator="{ on, attrs }">
                                <div class="fs-12 blue--text ml-3" v-bind="attrs" v-on="on" @click="reset(item); dialog.form_par = true;" style="cursor: pointer; font-weight: 500;">
                                  Ubah
                                </div>
                              </template>
  
                              <span>Ubah</span>
                            </v-tooltip>
                            <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div class="fs-12 green--text ml-3" v-bind="attrs" v-on="on" @click="dialog.form_par = true; resetSub(item);" style="cursor: pointer; font-weight: 500;">
                                    Tambah
                                  </div>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top
                                v-if="hak_akses.action.delete">
                                <template v-slot:activator="{ on, attrs }">
                                  <div class="fs-12 red--text ml-3" v-bind="attrs" v-on="on" @click="toDelete(item.id)" style="cursor: pointer; font-weight: 500;">
                                    Hapus
                                  </div>
                                </template>
                                
                                <span>Hapus</span>
                              </v-tooltip> 
                          </div> -->

                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: right;" :style="item.num_children === 0 ? index !== 0 ? ' border-top: solid #ededed;' : '' : ''">
                          <span v-if="item.num_children === 2">
                            {{ (item.volume*1) | number_dec }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;" :style="item.num_children === 0 ? index !== 0 ? ' border-top: solid #ededed;' : '' : ''">
                          <span v-if="item.num_children === 2">
                            {{ item.unit }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: right;" :style="item.num_children === 0 ? index !== 0 ? ' border-top: solid #ededed;' : '' : ''">
                          <span v-if="item.num_children === 2">
                            Rp {{ item.internal_price*1 | number_dec }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: right;" :style="item.num_children === 0 ? index !== 0 ? ' border-top: solid #ededed;' : '' : ''">
                          <span v-if="item.num_children === 2">
                            Rp {{ item.total_internal_price*1 | number_dec }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: right;" :style="item.num_children === 1 ? 'font-weight: 600;' : item.num_children === 0 ? index !== 0 ? 'font-weight: 700; border-top: solid #ededed;' : 'font-weight: 700;' : ''">
                          <span v-if="item.num_children !== 2">
                            Rp {{ item.total_internal_price*1 | number_dec }}
                          </span>
                        </td>
                      </tr>
                      <!-- <tr>
                        <th colspan="4" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Total</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Rp. 510.000.000</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Rp. 85.000.000</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></th>
                      </tr> -->
                    </table>
                  </div>
                  <v-card-text
                    v-if="list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum ada data Data RAB Internal
                      </div>
                    </div>
                  </v-card-text>
                </div>
                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>

              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    props: {
      detail_project: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        checkbox: false,
        menu2: false,
        filter: {
          start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().substr(0, 10),
          end_date: new Date().toISOString().substr(0, 10),
          coa: '',
          transaction: ''
        },

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,

          filter: false,
          form: false,
          warning: false,
          error: false,
          form_par: false,
          form_detail: false
        },
        
        search: '',
        awal_periode: 0,
        total_debit: 0,
        total_kredit: 0,
        akhir_periode: 0,

        // filter: {
          
        // },

        selected: {
          row: '',
          freeze: [],
          delete: [],
          reset: []
        },
        is_detail: false,

        name_par: '',
        num_children: 0,

        coa: [],
        client: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},

        lastIndex: 0,
        limit: 20,

        upload: {
          image: null,
          document: null
        },
        total: {
          internal: 0,
          public: 0
        },

        form: {
          id: '',
          name: '',
          par_id: '0',
          project_id: '',
          unit: '',
          volume: '',
        },

        form_detail: {
          id: '',
          name: '',
          rab_id: '',
          project_id: '',
          category: '',
          unit: '',
          // internal_price: '',
          // public_price: '',
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          form: false,
          export: false,
          image: false,
          document: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      Detail: () => import(/* webpackPrefetch: true */ '@/components/persiapan/detail.vue'),
    },
    watch: {
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 2) {
            menu = item
          }
        })
        return menu
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      toFilter(){
        if(this.filter.start_date === '' || this.filter.end_date === '' || this.filter.coa === '' || this.filter.coa === null){
          this.dialog.warning = true
        } else {
          this.fetch()
        }
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        
        this.paginationList = pagination
        
        this.process.load = true

        this.limit = pagination.row
        let params = {
          search: this.search,
          pagination_bool: false,
          project_id: this.$route.params.id,
          sort: '-id',
        }
        let url = 'project/rab/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list = []
            this.is_detail = false
            this.total = res.results.total
            res.results.data.map((item, index_par) => {
              this.list.push({
                ...item,
                num_children: 0,
                no_par: '',
                no: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                is_child: item.child.length > 0 ? true : false
              })
              if(item.child.length > 0){
                item.child.map((child, index) => {
                  if(child.child.length > 0){
                    this.list.push(
                      {
                        ...child,
                        num_children: 1,
                        no_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                        no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                        is_child: true
                      }
                    )
                    child.child.map((child2, index2) => {
                      this.is_detail = true
                      this.list.push(
                        {
                          ...child2,
                          num_children: 2,
                          no_par_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                          no_par:index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                          no: index2 + 1,
                          is_child: false
                        }
                      )
                    })
                  } else {
                    this.list.push(
                      {
                        ...child,
                        num_children: 1,
                        no_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                        no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                        is_child: false
                      }
                    )
                  }
                }
                )
                // item.child.map((child, index) => {
                //   this.list.push(
                //     {
                //       ...child,
                //       num_children: 1,
                //       no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : ''
                //     }
                //   )
                // })
                // item.child.map(child => {
                //   if(child.child.length > 0){
                //     child.child.map((child2, index2) => {
                //       this.list.push(
                //         {
                //           ...child2,
                //           num_children: 2,
                //           no: index2 + 1
                //         }
                //       )
                //     })
                //   }
                // })
              }
            })
            this.pagination = res.results.pagination !== undefined ? res.results.pagination : {}
            this.process.load = false
            // this.fetchSummary()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (item) {
        this.num_children = item !== undefined ? item.num_children : 0
        this.name_par = item !== undefined ? item.name : ''
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          name: item !== undefined ? item.name : '',
          par_id: item !== undefined ? item.par_id : '0',
          project_id: this.$route.params.id,
          unit: item !== undefined ? item.unit : '',
          volume: item !== undefined ? (item.volume*1).toString().split('.').join(',') : '',
          // internal_price: item !== undefined ? item.internal_price*1 : '',
          // public_price: item !== undefined ? item.public_price*1 : ''
        }

        this.process.form = false

        this.message.error = ''
      },

      resetSub(item) {
        this.name_par = item.name
        this.num_children = item.num_children === 0 ? 0 : item.num_children + 1
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: '',
          name: '',
          par_id: item !== undefined ? item.id : '0',
          project_id: this.$route.params.id,
          unit: '',
          volume: '',
          // internal_price: '',
          // public_price: ''
        }

        this.process.form = false

        this.message.error = ''
      },

      resetDetail(item) {
        this.name_par = item.name
        this.num_children = item.num_children
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form_detail = {
          id: '',
          name: '',
          rab_id: item !== undefined ? item.id : '0',
          project_id: this.$route.params.id,
          category: '',
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'project/rab/add' : 'project/rab/update'

          this.form.volume = (this.form.volume).toString().split(',').join('.')
          console.log(this.form)

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              // this.dialog.form === true ? this.dialog.form_par = false : this.dialog.form = false

              this.dialog.form_par = false

              this.dialog.snackbar = true
              this.message.success = res.message

              // this.dialog.fullscreen = false

              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch(this.paginationList)
              }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`project/rab/delete`, {
          data: {
            id: this.selected.delete[0],
            project_id: this.$route.params.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/client/export_excel`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper_internal { 
  overflow-y: auto; 
  height: calc(100vh - 325px); 
} 
.wrapper_internal th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-col {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  left: 0px;
}

.three-col {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  left: 80px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 80px;
}
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>